import { api } from "@/api";

// Returns the user's pinned market group numbers, e.g. [12, 45].
export const getPinnedMarkets = async ({
  signal
}: { signal?: AbortSignal } = {}): Promise<number[]> => {
  const res = await api.client.get(`/pinned-markets`, { signal });
  return res.data;
};
